import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "check-in-success" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Success!", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "message"
}
const _hoisted_4 = {
  key: 1,
  class: "message"
}
const _hoisted_5 = {
  key: 2,
  class: "description"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Thanks for your feedback!", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 3,
  class: "description"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("It looks like ")
const _hoisted_12 = { class: "name" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" hasn't confirmed the meeting just yet, but once they do you will see your Opt balance become available for withdrawal.")
const _hoisted_14 = { class: "btn-container button-container-checkin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($props.isPayer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Thank you for Confirming the meeting"))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "Thank you for your feedback")),
    ($props.isPayer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          ($props.meeting.status === $setup.Meetings.MeetingStatus.fullyConfirmed)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, " As soon as we're done processing the funds for this meeting, you will see your Opt balance become available for withdrawal."))
            : ($props.meeting.status === $setup.Meetings.MeetingStatus.payerConfirmed)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, _toDisplayString($setup.recipientName), 1 /* TEXT */),
                  _hoisted_13
                ]))
              : _createCommentVNode("v-if", true)
        ])),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "outline complete-check-in",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('progress')))
      }, _toDisplayString($props.isLoggedIn ? ($props.isPayer ? 'Opt Profile' : 'View Opt Balance') : 'Go to Login'), 1 /* TEXT */)
    ])
  ]))
}